import { IWebAdminAPI } from './definitions';
import { InjectionToken, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { ITaxpayersAPI } from './taxpayers/definitions';
import { TaxpayersAPI } from './taxpayers/main';
import { IRunManagementAPI } from './run-management/definitions';
import { RunManagementAPI } from './run-management/main';

export const WebAdminAPIToken = new InjectionToken<IWebAdminAPI>('WebAdminAPI');

// prettier-ignore
@Injectable()
export class WebAdminAPI implements IWebAdminAPI {
  public taxpayers: ITaxpayersAPI;
  public runManagement: IRunManagementAPI;

  public constructor(private http: HttpClient) {
    this.taxpayers = new TaxpayersAPI(http, environment.apiUrl)
    this.runManagement = new RunManagementAPI(http, environment.apiUrl)
  }
}
